import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ModeProviderComponent} from "./mode-provider.component";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [
    ModeProviderComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  exports: [
    ModeProviderComponent,
  ]
})
export class ModeProviderModule { }
